import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import '../../../public/css/orders-app/app.css'

import App from './App.vue'
import { installI18n } from './i18n'
import { useLanguageStore } from './stores/language'
import router from './router'
import VueGtag from "vue-gtag";

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)

app.use(VueGtag, {
    appName: 'L\'Apéro Gastrobar',
    pageTrackerScreenviewEnabled: true,
    config: {
        id: "G-8970BXE4Y9"
    }
}, router)

const i18n = installI18n(app)
app.mount('#app')

const l = useLanguageStore()

l.$subscribe((_, state) => {
    i18n.global.locale = state.currentAppLanguage;
})

l.fetchCurrentLanguage()
